import clsx from 'clsx';
import React from 'react';
import CheckmarkIcon from '../../images/icons/checkmark.svg';
import styles from './StepFormProgress.module.scss';
import StepFormSubStepButtons from './StepFormSubStepButtons';

export type StepsDescription = {
  title: string;
  desc: string;
};

interface Props {
  stepsDescriptions: StepsDescription[];
  activeMainStep: number;
  property: any;
  onStepClick: (step: number) => void;
  onBackClick?: () => void;
  onNextClick?: () => void;
  onPublishClick?: () => void;
  onSaveAndExitClick?: () => void;
}

export default function StepFormStepCompleted(props: Props) {
  const isPreviousStep = (idx: number) => idx < props.activeMainStep;

  const isActiveStep = (idx: number) => idx === props.activeMainStep;

  const isFutureStep = (idx: number) => idx > props.activeMainStep;

  const isFinalStep = props.activeMainStep >= props.stepsDescriptions.length;

  return (
    <div className={styles.container}>
      {props.stepsDescriptions.map((step, idx) => (
        <div
          key={idx}
          className={clsx(
            styles.stepBox,
            isFutureStep(idx) && styles.stepBoxDisabled,
            isPreviousStep(idx) && styles.stepBoxPrevious,
            isActiveStep(idx) && styles.stepBoxActive
          )}
        >
          <button type="button" onClick={() => props.onStepClick(idx)}>
            <h3>PASO {idx + 1}</h3>
            {isPreviousStep(idx) ? (
              <>
                <span>Finalizado</span>
                <img src={CheckmarkIcon} />
              </>
            ) : (
              <span>{step.title}</span>
            )}
          </button>

          {isPreviousStep(idx) && <p>{step.title}</p>}
        </div>
      ))}

      {isFinalStep ? (
        <StepFormSubStepButtons
          actions="saveAndExit"
          showPublishBtn={['borrador', 'publicacion pendiente'].includes(
            props.property?.status
          )}
          onPublishClick={props.onPublishClick}
          onSaveAndExitClick={props.onSaveAndExitClick}
        />
      ) : (
        <StepFormSubStepButtons
          onNextClick={props.onNextClick}
          onBackClick={props.onBackClick}
        />
      )}
    </div>
  );
}
